module.exports = __webpack_public_path__ + "img/Menu-11-.bc939a05.png";